<div [ngClass]="isChild? '' : 'grid-container padding-y-4'">
    <div class="grid-row grid-gap-1" [formGroup]="uploadForm">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--large" *ngIf="(userPermission!=null) && (userPermission === 4 || userPermission === 5 || userPermission === 6)">
                {{uploadTitle}}
                <ng-template #otherMessage>{{uploadTitle}}</ng-template>
            </legend>
            <legend class="usa-legend usa-legend--large" *ngIf="(userPermission===null)">{{uploadTitle}}</legend>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label maxw-full" *ngIf="showDownload">If you want to upload delivery data for multiple shipments, please upload it here.</label>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="fileUpload.status === 'done'">
            <div class="usa-alert usa-alert--success maxw-full">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">
                        {{fileUpload.message}}
                    </p>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="fileUpload.status === 'error'">
            <div class="usa-alert usa-alert--error maxw-full">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">
                        {{fileUpload.message}}
                    </p>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label maxw-full">
                Please click 'Choose File' to select a file to upload. It may take a few seconds for the 'file upload' window to appear.
            </label>
        </div>
      <!--TODO file validations-->
      <!--<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4" *ngIf="fileError">
        <div class="usa-alert usa-alert&#45;&#45;error usa-alert&#45;&#45;slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{fileError}}
            </p>
          </div>
        </div>
      </div>-->
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="customize-file-upload usa-label" for="filePicker">Input accepts a single file</label>
            <input id="filePicker" class="customized-upload-button maxw-full"  type="file" name="filePicker" formControlName="filePicker" id="filePicker" (change)="fInput($event);">
        </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
            <ul class="usa-button-group">
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button" [disabled]="!(!(uploadForm.invalid) && (fileUpload.status === 'ok') && (file !== null))" (click)="upload();">Click to upload file</button>
                </li>
            </ul>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <progressbar *ngIf="fileUpload.status === 'uploading'" class="progressBarStyle" max="100" [value]="fileUpload.message" type="success" [striped]="true" [animate]="true"><i>{{fileUpload.message}}%</i></progressbar>
        </div>
    </div>
</div>
